import { AxiosError } from 'axios';
import apiClient from 'utils/api-client';

export const get = async (
  onSuccess?: (res: GetCameras) => void,
  onFailed?: (error: AxiosError) => void
) => {
  await apiClient
    .get('/sd-recording-viewer-service/cameras')
    .then(res => {
      onSuccess && onSuccess(res.data);
    })
    .catch(error => {
      onFailed && onFailed(error);
    });
};

export interface GetCameras {
  cameras: CameraObject[];
}

export interface CameraObject {
  camera_id: string;
  camera_display_name: string;
  location_name: string;
  redirect_url: string;
}
